<div class="section" *ngIf="list?.length">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="row justify-content-between align-items-center">
                    <div class="col-auto">
                        <h3 class="heading">{{ "HOME.LATEST-RANKINGS" | translate }}</h3>
                    </div>
                    <div class="col-auto mb-3 mb-md-0">
                        <nb-select
                            placeholder="Departamentos"
                            [(ngModel)]="selectedDepartment"
                            (selectedChange)="onDepartmentChange($event)"
                        >
                            <nb-option *ngFor="let option of departmentFilters" [value]="option.id_depto">
                                {{ option.descricao }}
                            </nb-option>
                        </nb-select>
                    </div>
                </div>
            </div>
            <div class="col-lg-6" *ngFor="let ranking of list">
                <app-card-ranking
                    [ranking]="ranking"
                    [linkRoute]="'/' + ranking.url_redirect + '-classif'"
                ></app-card-ranking>
            </div>
        </div>
    </div>
</div>
